import PropTypes from 'prop-types'

import { getAssortmentsUiURL, getWorkspacesURL } from 'utils/links'

export const AssortmentLink = ({
  poLinkType,
  assortmentId,
  className = '',
  children,
}) => (
  <a href={getWorkspacesURL(assortmentId, poLinkType)} className={className}>
    {children}
  </a>
)

AssortmentLink.propTypes = {
  poLinkType: PropTypes.string,
  assortmentId: PropTypes.string.isRequired,
  brandId: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

AssortmentLink.defaultProps = {
  poLinkType: '/overview',
  brandId: null,
}

export const AssortmentUiLink = ({ assortmentId, children }) => (
  <a href={getAssortmentsUiURL(assortmentId)}>{children}</a>
)

AssortmentUiLink.propTypes = {
  assortmentId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}
